import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoadingSpinner from '../LoadingSpinner';
import './Button.scss';

const Button = ({
  children = null,
  label = null,
  className = '',
  colorScheme = 'blue',
  inverted = false,
  disabled = false,
  loading = false,
  IconLeft = null,
  IconRight = null,
  onMouseDown = undefined,
  onClick = () => {},
  tabIndex = null,
  type = 'submit',
  ariaLabel = null,
  open = false
}) => {
  // Leverage the classnames library to build the class string safely
  const buttonClass = classNames(
    'button',
    {
      'button--loading': loading,
      'button--disabled': disabled,
      // Safely apply the color scheme if not disabled
      [`button--${colorScheme}`]: !disabled && colorScheme, 
      '--inverted': inverted,
      '--open': open
    },
    className
  );

  const iconClass = 'button__icon';

  return (
    <button
      className={buttonClass}
      disabled={disabled}
      type={type}
      onMouseDown={onMouseDown}
      onClick={onClick}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
    >
      {IconLeft && <IconLeft width={24} height={24} className={iconClass} />}
      &nbsp;
      {children || label}
      {loading && <LoadingSpinner />}
      &nbsp;
      {IconRight && <IconRight width={24} height={24} className={iconClass} />}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  colorScheme: PropTypes.oneOf(['red', 'green', 'blue', 'basic']),
  disabled: PropTypes.bool,
  inverted: PropTypes.bool,
  loading: PropTypes.bool,
  IconLeft: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  IconRight: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onMouseDown: PropTypes.func,
  onClick: PropTypes.func,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  ariaLabel: PropTypes.string,
  open: PropTypes.bool
};

export default Button;
